import { render, staticRenderFns } from "./delete-tags-table.vue?vue&type=template&id=3192a074&scoped=true&"
import script from "./delete-tags-table.vue?vue&type=script&lang=js&"
export * from "./delete-tags-table.vue?vue&type=script&lang=js&"
import style0 from "./delete-tags-table.vue?vue&type=style&index=0&id=3192a074&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3192a074",
  null
  
)

export default component.exports